type RetryOptions = {
  maxAttempts?: number;    // Max number of times to try (default: 3)
  maxTimeMs?: number;      // Max time in ms to keep retrying
  delayMs?: number;        // Optional delay between attempts
};

export async function retry<T>(
  fn: () => Promise<T> | T,
  options: RetryOptions = {}
): Promise<T> {
  const {
    maxAttempts = 3,
    maxTimeMs,
    delayMs = 0
  } = options;

  const startTime = Date.now();
  let attempt = 0;
  let lastError: unknown;

  while (true) {
    attempt++;

    try {
      return await fn();
    } catch (error) {
      lastError = error;

      const elapsedTime = Date.now() - startTime;
      const timeExceeded = maxTimeMs !== undefined && elapsedTime >= maxTimeMs;
      const attemptsExceeded = attempt >= maxAttempts;

      if (timeExceeded || attemptsExceeded) {
        break;
      }

      if (delayMs > 0) {
        await new Promise((res) => setTimeout(res, delayMs));
      }
    }
  }

  throw new Error(
    `Failed after ${attempt} attempt(s)${maxTimeMs ? ` or ${maxTimeMs}ms` : ''}: ${String(lastError)}`
  );
}